import React from 'react'

import type { AlertSize, AlertVariant } from './model'
import type { Button } from 'components/shared/Button/Button'

export type AlertPropsContextValue = {
  buttonClassName?: string
  buttonColor?: React.ComponentProps<typeof Button>['color']
  buttonLabel?: React.ReactNode
  buttonSize?: React.ComponentProps<typeof Button>['size']
  buttonVariant?: React.ComponentProps<typeof Button>['variant']
  message?: React.ReactNode
  size?: AlertSize
  variant?: AlertVariant
}

export type AlertHandlersContextValue = {
  onAction?: () => void
}

export const AlertPropsContext = React.createContext<
  AlertPropsContextValue | undefined
>(undefined)
export const AlertHandlersContext = React.createContext<
  AlertHandlersContextValue | undefined
>(undefined)
